export enum EntityType {
  REVOCABLE_TRUST = 'REVOCABLE_TRUST',
  IRREVOCABLE_TRUST = 'IRREVOCABLE_TRUST',
  LIMITED_PARTNERSHIP = 'LIMITED_PARTNERSHIP',
  LLC = 'LLC',
  CORPORATION = 'CORPORATION',
}
